import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'
import { nanoid } from 'nanoid'

import { SpecialCategory, SpecialTour } from 'shared/api/tours/search'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { TagsFilter } from 'shared/ui/tags-filter'

import { SpecialToursCard } from './components/special-tours-card'
import s from './styles.module.scss'

interface Props {
  tours?: SpecialTour[]
  categories?: SpecialCategory[]
  onClickTour: (tour: SpecialTour) => void
  onClickAll?: () => void
  onTagClick?: (id: string) => void
}

export const SpecialToursUi = observer(
  ({ tours, onClickTour, onClickAll, categories, onTagClick }: Props) => {
    const { t } = useTranslation()

    return (
      <div
        id="special-tours"
        className={s.wrapper}
      >
        <div className={s.container}>
          <div className={s.hotToursHeader}>
            <p className={clsx(s.hotToursHeaderTitle, 'bold-16')}>
              {t('tours_block.best_offers')}
            </p>

            <div
              className={s.headerRightSide}
              onClick={onClickAll}
            >
              <p className={clsx('medium-16')}>{t('all')}</p>
              <AppIcon
                id={AllIcons.CHEVRON_RIGHT}
                width={12}
                height={12}
                className={s.arrowRight}
              />
            </div>
          </div>

          <div className={s.tags}>
            <TagsFilter
              tags={categories}
              defaultActive={categories?.[0]?.id}
              onClick={onTagClick}
            />
          </div>

          <div className={s.hotToursCards}>
            {tours?.map((item) => (
              <SpecialToursCard
                onClick={() => onClickTour(item)}
                data={item}
                key={nanoid()}
              />
            ))}
          </div>
        </div>
      </div>
    )
  },
)
